<template>
    <!-- Button that calls the sendWaiver method on click and is disabled based on isButtonDisabled -->
    <v-btn
      color="primary"
      elevation="2"
      @click="sendWaiver"
      :disabled="isButtonDisabled"
      class="btn-responsive btn-send-email"
    >
      <!-- Show different texts on the button based on the state -->
      {{ textBtn }}
    </v-btn>
</template>
  
<script>
import { VBtn } from 'vuetify/lib';
import { mapGetters } from 'vuex';
  
export default {
    name: "BtnSendEmail",
    components: {
      VBtn
    },
    props: {
      waiver: { type: Object, default: () => ({}) }, // Prop for the waiver object
      disabled: { type: Boolean, default: false }, // Prop to disable the button
      componentFather: { type: String, default: '' } // Prop for the parent component name
    },
    computed: {
      ...mapGetters({
        timersDisabled: 'getTimerStates' // Get timer states from Vuex
      }),
      isButtonDisabled() {
        // Computed property to determine if the button is disabled
        return this.disabled || this.disabledSend;
      },
      timerStatus() {
        // Computed property to find the specific timer for the current waiver
        const timer = this.timersDisabled.find(el => {
          const { waiverId, userId, componentName } = el;
          return componentName === this.componentFather && waiverId === this.waiver.fkWaiverId && userId === this.waiver.userId;
        });
        // Return the found timer or a default object
        return timer || { disabledSend: false, timeDisabled: 0 };
      },
      disabledSend() {
        // Computed property to get the disabledSend state
        return this.timerStatus.disabledSend;
      },
      timeDisabled() {
        // Computed property to get the remaining disabled time
        return this.timerStatus.timeDisabled;
      },
      textBtn() {
        // Computed property to get the text of the button
        return this.disabledSend ? 
          this.$t('registerEvent.enabled_time', { time: this.timeDisabled }) : 
          (this.waiver.waiverstatus !== 'Signed' ? this.$t('registerEvent.send_waiver', { name: this.waiver.fullName }) : this.$t('registerEvent.signed'))
      }
    },
    methods: {
      sendWaiver() {
        // Method to send the waiver if not disabled
        if (!this.disabledSend) {
          this.$emit('sendWaiver', this.waiver); // Emit sendWaiver event
          this.startCooldown(); // Start the cooldown period
        }
      },
      startCooldown() {
        // Method to start the cooldown period for the button
        const { fkWaiverId, userId } = this.waiver;
        this.$store.dispatch('startTimerDisabledAction', {
          waiverId: fkWaiverId,
          userId,
          componentName: this.componentFather
        });
      }
    },
    mounted() {
      // Dispatch action to set up the timer when the component is mounted
      const { fkWaiverId, userId } = this.waiver;
      this.$store.dispatch('settingTimer', {
        waiverId: fkWaiverId,
        userId,
        componentName: this.componentFather
      });
    }
};
</script>

<style>
  .btn-responsive {
    height: auto;
    min-height: 36px;
    display: block;
  }
  .btn-responsive span {
    white-space: normal;
  }

  .btn-send-email span {
    white-space: normal;
    display: contents;
  }
  .btn-send-email {
    min-height: 36px !important;
    height: auto !important;
  }
</style>
